//  fetch question hook to fetch api data and set value to store

import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { getServerData } from "../helper/helper"
import {data, answers, answersX, answersY } from "../redux/data"


// redux action
// import * as Action from '../redux/question_reducer'
import * as Action from "../redux/question_reducer"

/** fetch question hook to fetch api data and set value to store */
export const useFetchQuestion = () =>{
    const dispatch =  useDispatch()
    const [getData, setGetData] = useState({isLoading : false, apiData : [], serverError : null})
 
    useEffect(() => {
        setGetData(prev => ({...prev, isLoading : true}));

        // async function fetch backend data
        (async () => {
            try{
                // const [{questions, answers}] = await getServerData(`${process.env.REACT_APP_SERVER_HOSTNAME}/api/questions`,(data) => data)
                // dikko test
                const question = await data;

                if(question.length > 0){
                    setGetData(prev => ({...prev, isLoading : false}));
                    setGetData(prev => ({...prev, apiData : question}));

                    // dispatch an action
                     dispatch(Action.startExamAction({question, answers, answersX, answersY}))
                }
                else{
                    throw new Error('NO Question Available')
                }
            }
            catch(error){
                setGetData(prev => ({...prev, isLoading : false}))
                setGetData(prev => ({...prev, serverError : error}))
            }
        })();

    },[dispatch]);

    return [getData,setGetData];
}

// move action dispatch function
export const MovePaginationQuestion = (e) => async (dispatch) =>{
    try{
console.log(e)
           // dispatch an action

        dispatch(Action.movePaginationAction({e}))   
    }
    catch(error){
        console.log(error);
    }
}
export const MovePaginationQuestionX = (e) => async (dispatch) =>{
    try{
console.log(e)
           // dispatch an action

        dispatch(Action.movePaginationActionX({e}))   
    }
    catch(error){
        console.log(error);
    }
}
export const MovePaginationQuestionY = (e) => async (dispatch) =>{
    try{
console.log(e)
           // dispatch an action

        dispatch(Action.movePaginationActionY({e}))   
    }
    catch(error){
        console.log(error);
    }
}
// move action dispatch function
export const MoveNextQuestion = () => async (dispatch) =>{
    try{
        // icrease trace value by 1
        dispatch(Action.moveNextAction())   
    }
    catch(error){
        console.log(error);
    }
}
export const MoveNextQuestionX = () => async (dispatch) =>{
    try{
        // icrease trace value by 1
        dispatch(Action.moveNextActionX())   
    }
    catch(error){
        console.log(error);
    }
}
export const MoveNextQuestionY = () => async (dispatch) =>{
    try{
        // icrease trace value by 1
        dispatch(Action.moveNextActionY())   
    }
    catch(error){
        console.log(error);
    }
}

// prev action dispatch function
export const MovePrevQuestion = () => async (dispatch) =>{
    try{
        // decrease trace value by 1
        dispatch(Action.movePrevAction())
    }
    catch(error){
        console.log(error);
    }
}
export const MovePrevQuestionX = () => async (dispatch) =>{
    try{
        // decrease trace value by 1
        dispatch(Action.movePrevActionX())
    }
    catch(error){
        console.log(error);
    }
}
export const MovePrevQuestionY = () => async (dispatch) =>{
    try{
        // decrease trace value by 1
        dispatch(Action.movePrevActionY())
    }
    catch(error){
        console.log(error);
    }
}